import { Flow } from 'signup-constants/Flow';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { enrollOnFlow } from './experimentDefaults';
import { getIsGoogleCredentialAuthentication } from '../google-authentication/google-prompt/getIsGoogleCredentialAuthentication';
import { getFlowKey } from '../routing/getFlowKey';
import { getIsNewUserExperiment } from './ExperimentUtils';
import { getIsJapan } from '../utils/getIsJapan';
import { getIsMobile } from '../utils/deviceUtils';
import { SignupEmbedder } from 'signup-embedder';
import { getIntentKey } from '../routing/getIntentKey';
import { getIsEnglishLanguage } from '../i18n/LanguageUtils';
import { getQueryParam } from '../routing/getQueryParam';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ACQ0170, {
  shouldEnroll: state => {
    const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service, Flow.CmsFree];
    const isJapan = getIsJapan(state);
    const isOnActiveFlow = activeFlows.includes(getFlowKey());
    return isOnActiveFlow && isJapan;
  }
}], [ExperimentKeys.ACQ0173, {
  shouldEnroll: state => {
    const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service];
    const isNewUser = getIsNewUserExperiment(state);
    const isOnActiveFlow = activeFlows.includes(getFlowKey());
    const isJapan = getIsJapan(state);
    const isMobile = getIsMobile();
    const isEmbedded = SignupEmbedder.isActive();
    const intentKey = getIntentKey();
    const isComingFromGooglePrompt = getIsGoogleCredentialAuthentication(state);
    const isEnglishLanguage = getIsEnglishLanguage();
    return isNewUser && isOnActiveFlow && isEnglishLanguage && !isJapan && !isMobile && !isEmbedded && !intentKey && !isComingFromGooglePrompt;
  }
}], [ExperimentKeys.ACQ0175, {
  shouldEnroll: state => {
    const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service];
    const isNewUser = getIsNewUserExperiment(state);
    const isOnActiveFlow = activeFlows.includes(getFlowKey());
    const isJapan = getIsJapan(state);
    const isMobile = getIsMobile();
    const isEmbedded = SignupEmbedder.isActive();
    const intentKey = getIntentKey();
    const isComingFromGooglePrompt = getIsGoogleCredentialAuthentication(state);
    const isEnglishLanguage = getIsEnglishLanguage();
    const acq175Enabled = getQueryParam('acq175_enabled') === 'true';
    return isNewUser && isOnActiveFlow && isEnglishLanguage && acq175Enabled && !isJapan && !isMobile && !isEmbedded && !intentKey && !isComingFromGooglePrompt;
  }
}], [ExperimentKeys.ACQ0177, {
  shouldEnroll: state => {
    const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service];
    const isNewUser = getIsNewUserExperiment(state);
    const isOnActiveFlow = activeFlows.includes(getFlowKey());
    const isJapan = getIsJapan(state);
    const isMobile = getIsMobile();
    const isEmbedded = SignupEmbedder.isActive();
    const intentKey = getIntentKey();
    const isComingFromGooglePrompt = getIsGoogleCredentialAuthentication(state);
    const isEnglishLanguage = getIsEnglishLanguage();
    return isNewUser && isOnActiveFlow && isEnglishLanguage && !isJapan && !isMobile && !isEmbedded && !intentKey && !isComingFromGooglePrompt;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }
  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}